import { IconSize } from '@components/v2/types';
import type { CSSObject } from '@emotion/react';
import type { Theme } from '@mui/material';

export const ICON_SIZE: Record<IconSize, number> = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  /** @deprecated 24 não existe na escala do design system — não usar em código novo. */
  xl: 24,
};

export const WORKSPACE_PADDING = 1;
export const WORKSPACE_PADDING_MOBILE = 1;
export const WORKSPACE_BORDER_RADIUS = 16;
export const WORKSPACE_FRAME_PADDING = 1.5;
export const WORKSPACE_FRAME_BORDER_WIDTH = 1;

export const MIN_SCREEN_HEADER_HEIGHT = 48;

export const getWorkspaceFrameStyles = (theme: Theme): CSSObject => ({
  background: theme.palette.custom.layout.workspace,
  borderRadius: WORKSPACE_BORDER_RADIUS,
  border: `${WORKSPACE_FRAME_BORDER_WIDTH}px solid ${theme.palette.custom.border.secondary}`,
});
